import {type ReactNode} from 'react'
import {cn} from '~/design-system/utils'
import HgIcon, {type HgIconType} from '../../HgIcon'

export type HgDetailListItemProps = {
  iconType: HgIconType
  text: ReactNode
}

type HgDetailListProps = {
  title?: ReactNode
  listItems: HgDetailListItemProps[]
  className?: string
}

const HgDetailList = ({title, listItems, className}: HgDetailListProps) => (
  <div className={cn('flex flex-col space-y-s2', className)}>
    {title && <h3 className="text-text-default arcadia-heading-9">{title}</h3>}
    <ul>
      {listItems.map((item, index) => (
        <li key={index} className="flex items-center space-x-s2 text-text-subdued">
          <HgIcon iconType={item.iconType} size="small" />
          <span className="arcadia-body-2">{item.text}</span>
        </li>
      ))}
    </ul>
  </div>
)

export default HgDetailList
